interface LauncherProps {
  onClick: () => void;
}

export function Launcher({ onClick }: LauncherProps): React.JSX.Element {
  return (
    <button
      type="button"
      className="widget-launcher"
      onClick={onClick}
      aria-label="Open chat"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    </button>
  );
}
